import React from "react";
import { Container, TextContainer, Wrapper } from "./styled";

const Us = () => {
  return (
    <Container>
      <Wrapper>
        <TextContainer>
          <h2>Nosotros</h2>
          <img
            className="mobile-only"
            src="../assets/about-img-m.png"
            alt="basketball court"
          />
          <p>
            Somos una plataforma de video análisis deportivo, buscamos ayudar
            mediante la utilización de la tecnología a los equipos y jugadores a
            mejorar sus rendimientos y el desarrollo de su juego.
          </p>
          <p>
            Estamos en constante desarrollo y buscando nuevas formas de mejorar
            nuestra plataforma y seguir aprendiendo sobre el deporte. Para así
            poder generar nuevos conocimientos y técnicas que permiten seguir
            creciendo a los jugadores, entrenadores, equipos y el deporte en si.
          </p>
        </TextContainer>
      </Wrapper>
      <div className="about-img-container">
        <img src="../assets/about-img.jpeg" alt="basketball court" />
      </div>
    </Container>
  );
};

export default Us;
